<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/direct-manage/temp-snatch-task' }"
        >临时抓取任务</el-breadcrumb-item
      >
      <el-breadcrumb-item>新建任务</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      新建任务
    </h1>
    <div class="view-content">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-card class="box-card">
          <div class="card-content">
            <el-form-item label="选择经销商" prop="selectDealer">
              <el-tag
                style="margin-right: 10px;"
                v-if="form.selectDealer !== ''"
                >{{ form.selectDealer }}</el-tag
              >
              <el-button type="text" @click="openChooseDealer">选择</el-button>
            </el-form-item>

            <el-form-item label="选择报告类型" prop="reportType">
              <el-select
                v-model="form.reportType"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="文件拆分" prop="is_split_file" v-if="$store.state.companyInfo.account_row.show_file_split==1">
              <el-radio-group v-model="form.is_split_file">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>



          <el-form-item
            v-if="form.reportType == 7 && $store.state.companyInfo.account_row.show_file_diff==1"
            label="是否对比差异"
            prop="is_diff"
          >
            <el-radio-group v-model="form.is_diff">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>

            <el-form-item label="任务类型" prop="scrap_time_type">
              <el-radio-group v-model="form.scrap_time_type">
                <el-radio label="1">实时</el-radio>
                <el-radio label="2">定时</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item 
              v-if="form.scrap_time_type === '2'" 
              label="定时采集时间" 
              prop="scrap_time"
            >
              <el-date-picker
                v-model="form.scrap_time"
                type="datetime"
                placeholder="选择日期时间"
                :picker-options="scrapTimeOptions"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="defaultTime"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="安装类型" prop="is_new">
              <el-radio-group v-model="form.is_new">
                <el-radio label="1">新插件</el-radio>
                <el-radio label="0">老插件</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="编写SQL" class="new-textarea" prop="sqlText">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="form.sqlText"
                show-word-limit
              >
              </el-input>
            </el-form-item>
            <el-form-item label="" class="new-textarea" prop="sqlText">
              <el-button @click="syncSql"> 同步SQL </el-button>
            </el-form-item>
          </div>
        </el-card>
        <el-form-item class="no-lable">
          <el-button
            type="primary"
            @click="onSubmit('form')"
            :loading="isLoading"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
      <choose-dealer
        ref="chooseDealer"
        @saveChange="dealerSaveChange"
        :is-checkbox="false"
        :type="2"
        :table-head="[1]"
      ></choose-dealer>
    </div>
  </div>
</template>

<script>
import ChooseDealer from "@/components/ChooseDealer";
import { addTemporary, getLastExecSql } from "@/api/index";
import moment from 'moment';

export default {
  name: "newTask",
  components: {
    ChooseDealer
  },
  data: () => ({
    isLoading: false,
    selectionVal: [],
    form: {
      selectDealer: "",
      reportType: "",
      sqlText: "",
      is_split_file: "1",
      is_diff: '0',
      scrap_time_type: '1',
      scrap_time: '',
      is_new: '1'
    },
    options: [
      {
        value: "1",
        label: "销售日报"
      },
      {
        value: "2",
        label: "采购日报"
      },
      {
        value: "3",
        label: "库存日报"
      },
      {
        value: "4",
        label: "销售周报"
      },
      {
        value: "5",
        label: "采购周报"
      },
      {
        value: "6",
        label: "库存周报"
      },
      {
        value: "7",
        label: "销售月报"
      },
      {
        value: "8",
        label: "采购月报"
      },
      {
        value: "9",
        label: "库存月报"
      }
    ],
    rules: {
      selectDealer: [
        { required: true, message: "请选择经销商", trigger: "blur" }
      ],
      reportType: [
        { required: true, message: "请选择报告类型", trigger: "blur" }
      ],
      is_split_file: [
        { required: true, message: "请选择是否拆分", trigger: "blur" }
      ],
      is_diff: [
        { required: true, message: "请选择是否对比差异", trigger: "blur" }
      ],
      sqlText: [{ required: true, message: "请编写SQL", trigger: "blur" }],
      scrap_time_type: [
        { required: true, message: "请选择任务类型", trigger: "change" }
      ],
      scrap_time: [
        { required: true, message: "请选择定时采集时间", trigger: "change" }
      ],
      is_new: [
        { required: true, message: "请选择安装类型", trigger: "change" }
      ],
    },
    defaultTime: new Date().toTimeString().slice(0,8),
    scrapTimeOptions: {
      disabledDate(time) {
        return time.getTime() < Date.now() - 8.64e7;
      }
    }
  }),
  watch: {
    'form.scrap_time_type'(val) {
      if (val === '2' && !this.form.scrap_time) {
        this.form.scrap_time = moment().format('YYYY-MM-DD HH:mm:ss');
      }
    }
  },
  methods: {
    dealerSaveChange(selectionVal) {
      this.selectionVal = selectionVal;
      this.form.selectDealer = selectionVal[0].client_name;
    },
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.form.scrap_time_type === '2') {
            const now = moment();
            const selectedTime = moment(this.form.scrap_time);
            if (selectedTime.isBefore(now)) {
              this.$message.error('采集开始时间不能早于当前时间');
              return;
            }
          }

          this.isLoading = true;
          let values = { ...this[formName] };
          let parameter = {
            client_id: this.selectionVal[0].client_id,
            sql: values.sqlText,
            client_name: this.selectionVal[0].client_name,
            plugin_code: this.selectionVal[0].plugin_code,
            client_code: this.selectionVal[0].client_code,
            report_type: values.reportType,
            is_split_file: values.is_split_file,
            scrap_time_type: values.scrap_time_type,
            scrap_time: values.scrap_time_type === '2' ? values.scrap_time : '',
            is_new: values.is_new
          };
          
          if(values.reportType == 7){
            parameter.is_diff = values.is_diff
          }

          addTemporary(parameter).then(res => {
            this.isLoading = false;
            if (0 === res.status) {
              this.$message({
                message: res.msg,
                type: "success"
              });
              this.$router.push({ path: "/direct-manage/temp-snatch-task" });
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },

    openChooseDealer() {
      this.$refs.chooseDealer.openDialog(this.selectionVal);
    },

    syncSql() {
      console.log(this.selectionVal, 'this.selectionValthis.selectionVal');
      if (!this.selectionVal.length) return this.$message.warning("请选择经销商");
      else if (!this.form.reportType) return this.$message.warning("请选择报告类型");
      else {
        let parameter = {
          client_id: this.selectionVal[0].client_id,
          report_type: this.form.reportType
        };
        getLastExecSql(parameter).then(res => {
          if (res.status == 0) {
            this.form.sqlText = res.data.sql;
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },

    resetForm() {
      this.form = {
        selectDealer: "",
        reportType: "",
        sqlText: "",
        is_split_file: "1",
        is_diff: '0',
        scrap_time_type: '1',
        scrap_time: "",
        is_new: '1'
      };
    }
  }
};
</script>

<style scoped lang="scss">
.box-card {
  margin-bottom: 20px;
}
</style>
